// extracted by mini-css-extract-plugin
export default {"container":"VehicleOwner_container__nEfEv","page":"VehicleOwner_page__dvFBl","section":"VehicleOwner_section__l4OaX"};